import { render, staticRenderFns } from "./MedicalInfoTables.vue?vue&type=template&id=47edd108&scoped=true&"
import script from "./MedicalInfoTables.vue?vue&type=script&lang=js&"
export * from "./MedicalInfoTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47edd108",
  null
  
)

export default component.exports